import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type State = {
  showGrid: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setShowGrid: (visible: boolean) => void
}

const usePersistStore = create(
  persist<State & Actions>(
    (set) => ({
      showGrid: false,
      setShowGrid: (showGrid) => set(() => ({ showGrid }))
    }),
    {
      name: 'grid-helper', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage) // (optional) by default, 'localStorage' is used
    }
  )
)

export { usePersistStore }
